module.exports = {
  container: {
    title: 'Lightweight, Open, and SecureWeb3 Infrastructure',
    content:
      'BitFlow aims to build a stable, reliable, and secure blockchain infrastructure,aggregate mainstream public chain nodes across the network, provide convenient LSD staking services,and maintain the stability and liquidity of digital assets.',
    info: 'Networks: 10+ Partners: 20+ Community users: 20,000+',
    button: 'Stake Now',
  },
  intro: {
    title: 'BitFlow Core Functions',
    coinTitle1: 'Non-custodial Staking',
    coinContent1:
      "Through decentralized nodes, users' assets are kept in their own wallets, and BitFlow only keeps the validate key without touching the withdrawal key.",
    coinTitle2: 'Liquidity Staking',
    coinContent2:
      'Provide secure and convenient liquidity staking services, use polymorphic oracles to obtain liquidity from major DEXs, and maintain price stability.',
    coinTitle3: 'LSO',
    coinContent3:
      'Stake-to-mine, a new token financing model. Users only need to stake tokens and lock on the platform to receive mining rewards.',
  },
  advantage: {
    title: 'BitFlow Highlights',
    title2: 'Provide secure, efficient and reliable LSD staking services',
    content:
      'Through a globally distributed node infrastructure, BitFlow builds a more collaborative and powerful multi-chain ecosystem. As the foundational layer of Web3, DeFi, and crypto finance, BitFlow allows users to participate in LSD staking services in a risk-diversified, auto-managed, and efficient manner. By connecting the world through digital assets, BitFlow is pioneering a new era of digital ecological applications.',
  },
  more: {
    title: 'Innovative, Efficient and Convenient',
    content:
      'BitFlow enables users to use their staked tokens to access and explore BitFlow-integrated Web3 applications and DeFi services.',
    button: 'Learn more',
    boxTitle1: 'Multi-chain Staking',
    boxContent1:
      'The current cooperative public chains include ETH, BNB, Polygon, ARB, SUI, etc., and more blockchain networks will be supported in the future.',
    boxTitle2: 'Decentralized',
    boxContent2:
      'Staking participants and node operators are freely matched, with creation, withdrawal, and reward delegation all handled by smart contracts at the execution layer.',
    boxTitle3: 'Node Management',
    boxContent3:
      'Support users to deploy their own validators for node management, provide cloud service support, and save synchronization time.',
    boxTitle4: 'Block Monitoring',
    boxContent4:
      'BitFlow monitors all nodes and API services in real time around the clock, and presents more comprehensive and intuitive data to users.',
    boxTitle5: 'Compound Yield',
    boxContent5:
      'Unlocking the liquidity of digital assets, users can earn multiple yields through staking, liquidity mining, and referral commissions.',
  },
  ecology: {
    title: 'BitFlow Ecosystem, Staking the Future',
    content: 'Exploring Web3 application and DeFi services',
  },
  media: 'Global Partners',
  bitFlowIntro: {
    content:
      "The world's first perfect token economy model of decentralized spiral perpetual motion mechanism, creating a decentralized and distributed strongest web3 infrastructure platform to build a sustainable withdrawal machine.",
  },
  transaction: {
    wallet: 'Connect Wallet',
    assets: {
      title: 'My Power',
      content: 'My Power',
      text1: 'Deposit',
      text2: 'Trade',
      text3: 'Transfer',
      text4: 'Replacement',
      text5: 'Assets',
    },
    place: {
      tab1: 'Place Order',
      tab2: 'Re-Sub Order',
      text1: 'USDT Balance',
      text2: 'FLOW Balance',
      mask: 'You have not bound the upper-level wallet and cannot place an order.',
      maskLight: 'Bind now.',
      payNeed: 'Pay Required',
      confirm: 'Confirm Order',
      contact: 'Contact us',
      maskInputTitle: 'Link Account',
      maskInputContent: 'Please link a valid account to link successfully!',
      placeholder: 'Please enter a valid account',
      confirmLink: 'Confirm to Link',
    },
  },
}
